import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useTTS } from "../../../../../hooks/useTTS";
import { setSection, updateSection } from "../../../assignmentSlice";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import VocaMatchingPage from "../../analysis/vocabulary/VocaMatchingPage";
import VocaStudyPage from "../../analysis/vocabulary/VocaStudyPage";
import CommonPage from "../../common/CommonPage";

const MatchingPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);

  const currentPage = pageList[currentIndex] || { type: "", data: {} };

  useEffect(() => {
    if (pageList.length > 0) {
      return;
    }

    // 저장해 둔 진도가 있으면 그것으로 되살린다. 예전에는 늘 문제에서 새로 만들어,
    // **아이가 매칭을 다 맞히고 나가도 다음에 1번으로 되돌아왔다**
    // (2026-08-31 무무거모 신고). 맞힌 기록은 서버에 남아 있었는데 화면이 버렸다.
    if (
      !isPreview &&
      Array.isArray(section.answer) &&
      section.answer.length > 0
    ) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }

    const tempPageList = [];
    const words = section.question.words.map((element) => {
      return {
        eng: element.word,
        kor: element.kor.split("\n")[0].replace(/\[.*?\]\s*/g, ""),
      };
    });

    for (let i = 0; i < Math.ceil(words.length / 10); i++) {
      tempPageList.push({
        type: "study",
        data: words.slice(i * 10, (i + 1) * 10).map((word) => {
          return { ...word, isOpened: false };
        }),
        isSubmitted: false,
      });
    }
    for (let i = 0; i < Math.ceil(words.length / 5); i++) {
      tempPageList.push({
        type: "matching",
        data: words.slice(i * 5, (i + 1) * 5).map((word) => {
          return { ...word, isMatched: false };
        }),
        isSubmitted: false,
      });
    }
    setPageList(tempPageList);
    setCurrentIndex(0);
  }, [section]);

  const handleNextPage = () => {
    // 낱말을 보기만 하는 쪽은 넘어갈 때 '봤다' 로 남긴다. 짝맞추기 쪽은 다 맞히면
    // VocaMatchingPage 가 스스로 표시한다. 이 표시가 이어하기 지점의 근거다.
    const newPageList = pageList.map((page, pageIndex) =>
      pageIndex === currentIndex && page.type === "study"
        ? { ...page, isSubmitted: true }
        : page
    );
    setPageList(newPageList);
    if (!isPreview && !isReview) {
      dispatch(setSection({ ...section, answer: newPageList }));
    }

    if (currentIndex + 1 < pageList.length) {
      setCurrentIndex(currentIndex + 1);
    } else {
      if (!isPreview && !isReview) {
        dispatch(
          updateSection({
            sectionId: section.id,
            data: {
              answer: newPageList,
              is_finished: newPageList.every((page) => page.isSubmitted),
            },
          })
        );
      }
      alert("매칭게임 학습 완료했습니다.");
      setCurrentStep(2);
    }
  };

  const handlePreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <CommonPage
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      currentPage={currentPage}
      currentIndex={currentIndex}
      totalNo={pageList.length}
    >
      {currentPage.type === "matching" && (
        <VocaMatchingPage
          currentPage={currentPage}
          section={section}
          pageList={pageList}
          setPageList={setPageList}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          isReview={isReview}
          type={"vocabulary"}
        />
      )}
      {currentPage.type === "study" && (
        <VocaStudyPage
          currentPage={currentPage}
          section={section}
          pageList={pageList}
          setPageList={setPageList}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          isReview={isReview}
          type={"vocabulary"}
        />
      )}
    </CommonPage>
  );
};

export default MatchingPage;
